import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import getCookies from 'commons/getCookies';
import PDPKeySellingPointsV1 from './PDPKeySellingPointsV1';
import PDPKeySellingPointsV2 from './PDPKeySellingPointsV2';
const KSP_V2_KEY = 'v2_ksp';
const PDPKeySellingPoints = t0 => {
  const $ = _c(5);
  const {
    mobileCarousel: t1
  } = t0;
  const mobileCarousel = t1 === undefined ? false : t1;
  const [useV2, setUseV2] = React.useState(true);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const value = getCookies()?.get(KSP_V2_KEY);
      if (value && String(value).trim() === "false") {
        setUseV2(false);
      }
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  React.useEffect(t2, t3);
  if (useV2) {
    let t4;
    if ($[2] !== mobileCarousel) {
      t4 = <PDPKeySellingPointsV2 mobileCarousel={mobileCarousel} />;
      $[2] = mobileCarousel;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PDPKeySellingPointsV1 />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
PDPKeySellingPoints.propTypes = {
  // The layout revamp shows one selling point at a time on mobile
  mobileCarousel: PropTypes.bool
};
export default PDPKeySellingPoints;